module.exports = require("eth-lib/lib/nat");